export default __webpack_public_path__ + "static/media/moments.d1b11805.svg";